var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

export const cardWidthAdjust = _ => {
    let card = document.getElementsByClassName("el-card__body");
    for (let index = 0; index < card.length; index++) {
        let wid = card[index]["offsetWidth"];
        let widInt = parseInt(parseInt(wid) / 100);

        widInt = widInt === 15 || widInt === 16 ? 14.7 : widInt;

        card[index].style.width = (widInt * 100) + "px";
    }
};
export default {
    /**
     * 传入数组关键字过滤返回
     * @param {String} val 过滤关键字，逗号隔开
     *
     * @return {string} 过滤后的数组
     */
    showAsThousand: function (val) {
        if (val === null || val === "0") {
            return "0";
        }

        if (val > 1000) {
            return val.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
        } else {
            return val;
        }
    },
    /**
     * 传入数组关键字过滤返回
     * @param {Array} list 待过滤数组
     * @param {string} val 过滤关键字，逗号隔开
     * @param {string} field 数组元素的过滤属性名称
     *
     * @return {Array} 过滤后的数组
     */
    filterMultiKey: function (val, list, field) {
        let copy = val.replace(/，/ig, ',');
        let key = ".*" + copy.replace(/,/ig, '\.\*') + ".*";

        let n = [];
        for (let i = 0; i < list.length; i++) {
            //因为需要全局匹配，所以在循环中每次创建新的正则，不复用，这样解决索引不一致问题
            let pattern = new RegExp('(' + key + ')', "ig");
            if (pattern.test(list[i][field])) {
                n.push(list[i]);
            }
        }

        return n;
    },
    /**
     * 除2向上取整
     * @param {number} n
     *
     * @return {number}
     */
    powerOfTwo(n) {
        return (n &= (n - 1)) !== 0 ? (n + 1) / 2 : n / 2;
        // return (n / 2) + (n % 2);
    },
    /**
     * 字符串结果转为二维数组
     * @param {string} resultRaw 待处理字符串
     *
     * @return {Array} 二维数组
     */
    evalStringToArray(resultRaw) {
        //为了兼容iso，使用这种增加切割位。
        let formats = resultRaw.replace(/([！。])/g, "$1@");
        const array = formats.split(/@/);

        const a = [];//。
        const b = [];//!

        for (let i = 0; i < array.length; i++) {
            if (!array[i] || array[i] === "")
                continue;

            if (array[i].indexOf("。") !== -1) {
                a.push(array[i]);
            } else {
                b.push(array[i]);
            }
        }

        const lenOfA = Math.ceil(a.length / 2)
        const lenOfB = Math.ceil(b.length / 2);
        const result = new Array(lenOfA + lenOfB);

        for (let i = 0; i < result.length; i++) {
            result[i] = new Array(2); //每行有2列
            if (lenOfB !== 0 && i <= lenOfB) {
                result[i][0] = b[i * 2];
                result[i][1] = b[i * 2 + 1];
            } else {
                let t = i - lenOfB;
                result[i][0] = a[i * 2];
                result[i][1] = a[i * 2 + 1];
            }
        }
        return result;
    },
    deepCopyObj: one,
    formatDate: {
        format: function (date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        }

    },
    // valid ID
    IDCard: function (val) {
        // return /(^[0-9]{17}([0-9]|[Xx])$)|(^[0-9]{17}$)/.test(_v);
        var area = {
            11: "北京",
            12: "天津",
            13: "河北",
            14: "山西",
            15: "内蒙古",
            21: "辽宁",
            22: "吉林",
            23: "黑龙江",
            31: "上海",
            32: "江苏",
            33: "浙江",
            34: "安徽",
            35: "福建",
            36: "江西",
            37: "山东",
            41: "河南",
            42: "湖北",
            43: "湖南",
            44: "广东",
            45: "广西",
            46: "海南",
            50: "重庆",
            51: "四川",
            52: "贵州",
            53: "云南",
            54: "西藏",
            61: "陕西",
            62: "甘肃",
            63: "青海",
            64: "宁夏",
            65: "新疆",
            71: "台湾",
            81: "香港",
            82: "澳门",
            91: "国外"
        }
        var Y, JYM;
        var S, M;
        var idcard_array = new Array();
        idcard_array = val.split("");
        var ereg

        // 地区检验
        if (area[parseInt(val.substr(0, 2))] == null) {
            return {
                valid: false,
                msg: "身份证号码地区非法！"
            }
        }
        // 身份号码位数及格式检验
        switch (val.length) {
            case 15:
                if ((parseInt(val.substr(6, 2)) + 1900) % 4 == 0
                    || ((parseInt(val.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(val
                            .substr(6, 2)) + 1900)
                        % 4 == 0)) {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;// 测试出生日期的合法性
                } else {
                    ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;// 测试出生日期的合法性
                }
                if (ereg.test(val))
                    return {
                        valid: true,
                        msg: ''
                    }

                else {
                    return {
                        valid: false,
                        msg: "身份证号码出生日期超出范围！"
                    }
                }
                break;
            case 18:
                // 18位身份号码检测
                // 出生日期的合法性检查
                // 闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
                // 平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
                if (parseInt(val.substr(6, 4)) % 4 == 0
                    || (parseInt(val.substr(6, 4)) % 100 == 0 && parseInt(val
                            .substr(6, 4))
                        % 4 == 0)) {
                    //ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;// 闰年出生日期的合法性正则表达式
                    ereg = /^[1-9][0-9]{5}(19|2[0-9])[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;// 闰年出生日期的合法性正则表达式
                } else {
                    //ereg = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;// 平年出生日期的合法性正则表达式
                    ereg = /^[1-9][0-9]{5}(19|2[0-9])[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;// 平年出生日期的合法性正则表达式
                }
                if (ereg.test(val)) {// 测试出生日期的合法性
                    // 计算校验位
                    S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10]))
                        * 7
                        + (parseInt(idcard_array[1]) + parseInt(idcard_array[11]))
                        * 9
                        + (parseInt(idcard_array[2]) + parseInt(idcard_array[12]))
                        * 10
                        + (parseInt(idcard_array[3]) + parseInt(idcard_array[13]))
                        * 5
                        + (parseInt(idcard_array[4]) + parseInt(idcard_array[14]))
                        * 8
                        + (parseInt(idcard_array[5]) + parseInt(idcard_array[15]))
                        * 4
                        + (parseInt(idcard_array[6]) + parseInt(idcard_array[16]))
                        * 2
                        + parseInt(idcard_array[7])
                        * 1
                        + parseInt(idcard_array[8])
                        * 6
                        + parseInt(idcard_array[9]) * 3;
                    Y = S % 11;
                    M = "F";
                    JYM = "10X98765432";
                    M = JYM.substr(Y, 1);// 判断校验位
                    // alert(idcard_array[17]);
                    if (M == idcard_array[17]) {
                        return {
                            valid: true,
                            msg: ''
                        } // 检测ID的校验位
                    } else {
                        // msg = "身份证号码末位校验位校验出错,请注意X的大小写";
                        //						msg = "身份证号码末位校验位校验出错！";
                        return {
                            valid: false,
                            msg: "身份证号码末位校验出错！"
                        }
                    }
                } else {
                    return {
                        valid: false,
                        msg: "身份证号码出生日期超出范围！"
                    }
                }
                break;
            default:
                return {
                    valid: false,
                    msg: "身份证号码位数有误,应该为15位或18位！"
                }
        }
    },

    // 组织机构代码校验
    adjustOrgNo: function (val, field) {
        var Errors = new Array("组织机构代码长度小于9，请重新输入！", "请输入正确的组织机构代码！");
        var orgNo = val;
        if (orgNo.length < 9) {
            return {
                valid: false,
                msg: Errors[0]
            }
        }

        var org_str = new Array();
        var k = 0;
        while (k < orgNo.length) {
            org_str[k] = orgNo.charCodeAt(k);
            k = k + 1;
        }
        var out_org = new Array(20);
        var w_i = [3, 7, 9, 10, 5, 8, 4, 2];
        var c_i = new Array(10);
        var i, j, c, s = 0;
        var fir_value, sec_value;
        if (org_str[8] != 45) { // 第9位必须是“-”号，否则不合法
            return {
                valid: false,
                msg: Errors[1]
            }
        }
        for (i = 0; i < 10; i++) {// 含有小写英文字母，不合法
            c = org_str[i];
            if (c <= 122 && c >= 97) {
                return {
                    valid: false,
                    msg: Errors[1]
                }
            }
            out_org[i] = c;
        }
        fir_value = org_str[0];
        sec_value = org_str[1];
        if (fir_value >= 65 && fir_value <= 90) {// 第一位含有大写英文字母，转换
            c_i[0] = (fir_value + 32) - 87;
        } else if (fir_value >= 48 && fir_value <= 57) {// 第一位在0-9范围内，
            c_i[0] = fir_value - 48;
        } else {// 第一位不是大写的英文字母 也不是数字 不合法
            return {
                valid: false,
                msg: Errors[1]
            }
        }
        s += w_i[0] * c_i[0];
        if (sec_value >= 65 && sec_value <= 90) {
            c_i[1] = (sec_value - 65) + 10;
        } else if (sec_value >= 48 && sec_value <= 57) {
            c_i[1] = sec_value - 48;
        } else {
            return {
                valid: false,
                msg: Errors[1]
            }
        }
        s += w_i[1] * c_i[1];
        for (j = 2; j < 8; j++) {
            if (org_str[j] < 48 || org_str[j] > 57) {
                return {
                    valid: false,
                    msg: Errors[1]
                }
            }
            c_i[j] = org_str[j] - 48;
            s += w_i[j] * c_i[j];
        }
        c = 11 - s % 11;
        out_org[9] = c + 48;
        if (c == 10)
            out_org[9] = 88;
        if (c == 11)
            out_org[9] = 48;
        if (org_str[9] == 88 && c == 10 || c == 11 && org_str[9] == 48
            || c == org_str[9] - 48) {
            return {
                valid: true,
                msg: ''
            } // 校验通过
        } else {
            return {
                valid: false,
                msg: Errors[1]
            }
        }
    },

    //统一信用代码
    uniteCreditNo: function (val, field) {
        switch (val.length) {
            case 18:
                var patrn = /^[0-9A-Z]+$/;
                // 18位校验及大写校验
                if ((val.length != 18) || (patrn.test(val) == false)) {
                    return {
                        valid: false,
                        msg: "请输入正确的统一信用代码"
                    }
                } else {
                    var Ancode;// 统一社会信用代码的每一个值
                    var Ancodevalue;// 统一社会信用代码每一个值的权重
                    var total = 0;
                    var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];// 加权因子
                    var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
                    // 不用I、O、S、V、Z
                    for (var i = 0; i < val.length - 1; i++) {
                        Ancode = val.substring(i, i + 1);
                        Ancodevalue = str.indexOf(Ancode);
                        total = total + Ancodevalue * weightedfactors[i];
                        // 权重与加权因子相乘之和
                    }
                    var logiccheckcode = 31 - total % 31;

                    if (logiccheckcode == 31) {
                        logiccheckcode = 0;
                    }
                    var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
                    var Array_Str = Str.split(',');
                    logiccheckcode = Array_Str[logiccheckcode];

                    var checkcode = val.substring(17, 18);
                    if (logiccheckcode != checkcode) {
                        return {
                            valid: false,
                            msg: "请输入正确的统一信用代码"
                        }
                    } else {
                        return {
                            valid: true,
                            msg: ""
                        }
                    }
                }
            default:
                return {
                    valid: false,
                    msg: "请输入正确的统一信用代码"
                }
        }
    },

    // 营业执照号码校验
    codeXy: function (val, field) {
        var Errors = new Array("请输入正确的营业执照号码", "");
        var no = String(val); // 将营业执照号码转换成String类型
        var reg = new RegExp("\d{15}");
        if (reg.test(no)) {
            return {
                valid: false,
                msg: Errors[0]
            }
        }
        var m, n, s, p, i;
        var value;
        var p = 10;
        var m = 10;
        var n = 11;
        for (var i = 1; i <= 14; i++) {
            value = no.substr(i - 1, 1);
            s = Number(value);
            p = p + s;
            p = p % m;
            if (p == 0) {
                p = m;
            }
            p = p * 2;
            p = p % n;
        }
        value = no.substr(14, 1);
        p = p + Number(value);
        p = p % m;
        if (p == 1) {
            return {
                valid: true,
                msg: ''
            }
        } else {
            var check = new RegExp('^\\d{6}(n|N)([a-z]|[0-9]|[A-Z]){1}\\d{6}(x|X)$');
            if (check.test(no)) {
                return {
                    valid: true,
                    msg: ''
                }
            }
            check = new RegExp('^([0-9]|[a-z]){13}$');
            if (check.test(no)) {
                return {
                    valid: true,
                    msg: ''
                }
            }
            return {
                valid: false,
                msg: Errors[0]
            }
        }
    },

    // 手机号码校验
    mobilePhone: function (val, field) {
        // var mobileReg = new RegExp("^1\\d{10}$");
        /*try {
            if (/^1[3458]\d{9}$/.test(val))
                return true;
            return false;
        } catch (e) {
            return false;
        }*/
        if (/^1[3456789]\d{9}$/.test(val)) {
            return true;
        } else {
            return false;
        }
    },
    //用户电话校验
    tel: function (val) {
        //if (/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(val)){
        if (/^((0\d{2,3})(-)?)(\d{7,8})(-(\d{3,}))?$/.test(val)) {
            return true;
        } else {
            return false;
        }
    },

    //******************* 金额格式化 千位分隔符 *******************
    FormatCurrency(num) {
        if (num != undefined) {
            num = num.toString().replace(/\$|\,/g, '');
            if (isNaN(num))
                num = "0";
            var sign = (num == (num = Math.abs(num)));
            num = Math.floor(num * 100 + 0.50000000001);
            var cents = num % 100;
            num = Math.floor(num / 100).toString();
            if (cents < 10)
                cents = "0" + cents;
            for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
                num = num.substring(0, num.length - (4 * i + 3)) + ',' +
                    num.substring(num.length - (4 * i + 3));
            return (((sign) ? '' : '-') + num + '.' + cents);
        }
    },
    // 取消千位分隔符
    Delcommafy(num) {
        if (num != undefined) {
            num = num.toString();
            num = num.replace(/[ ]/g, ""); //去除空格
            num = num.replace(/,/gi, '');
            return Number(num);
        }
    },
    getMenuId(path) {
        var menuId = '';
        var menuList = JSON.parse(sessionStorage.getItem('menuList'));
        if (menuList && menuList.length > 0) {
            menuList.forEach(element => {
                if (element.children && element.children.length > 0) {
                    element.children.forEach(ele => {
                        if (ele.menuUrl == path) {
                            menuId = ele.menuId
                        }
                    })
                } else {
                    if (element.menuUrl == path) {
                        menuId = ele.menuId
                    }
                }
            });
        }
        return menuId;
    },
    getContentOfPid(path) {
        var contentOfPid = '';
        var menuList = JSON.parse(sessionStorage.getItem('menuList'));
        if (menuList && menuList.length > 0) {
            menuList.forEach(element => {
                if (element.children && element.children.length > 0) {
                    element.children.forEach(ele => {
                        if (ele.menuUrl == path) {
                            if (ele.contentOfPid && ele.contentOfPid != "") {
                                contentOfPid = ele.contentOfPid
                            } else {
                                contentOfPid = "";
                            }
                        }
                    })
                } else {
                    if (element.menuUrl == path) {
                        if (element.contentOfPid && element.contentOfPid != "") {
                            contentOfPid = element.contentOfPid
                        } else {
                            contentOfPid = "";
                        }
                    }
                }
            });
        }
        return contentOfPid;
    },
};

function one(oldObj) {
    var newObj = {};
    if (oldObj && typeof oldObj == "object") {
        for (let i in oldObj) {
            if (typeof oldObj[i] == "object") {//如果子还是对象那么循环调用值赋值

                newObj[i] = one(oldObj[i]);
            } else {//直接值赋值
                newObj[i] = oldObj[i];
            }
        }
        return newObj
    }
}



// WEBPACK FOOTER //
// ./src/common/js/util.js